<div id="dept-maths" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Department of Mathematics</h2>
    <p class="inner-lead mt-3">
      The Department of Mathematics at Shah Satnam Ji Girls' College, Sirsa develops strong analytical and problem-solving skills in students. The department caters to all streams offering mathematics at undergraduate and postgraduate levels.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Courses Offered</h4>
    <ul class="inner-lead">
      <li>Mathematics as a subject in BA, B.Sc (Non-Med), B.Sc (Comp. Sci.), BAJMC, BBA, B.Com (Voc.), B.Com (Gen.)</li>
      <li>M.Sc Mathematics (PG) — 2 Years</li>
    </ul>

    <hr class="divider">

    <h4 class="section-subtitle">Faculty</h4>
    <div class="table-responsive-inner mt-3">
      <table class="inner-table">
        <thead>
          <tr>
            <th>Sr. No.</th>
            <th>Name</th>
            <th>Qualification</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>1</td><td>Ms. Pooja Taneja</td><td>M.Phil., M.Sc (Maths), B.Ed., HTET, CTET</td></tr>
          <tr><td>2</td><td>Ms. Madhu Bala</td><td>M.Sc (Maths), B.Ed., HTET, CTET</td></tr>
          <tr><td>3</td><td>Ms. Avnee</td><td>M.Sc. (Maths), B.Ed.</td></tr>
          <tr><td>4</td><td>Ms. Shilpa Arora</td><td>M.Sc (Maths), B.Ed., HTET, CTET</td></tr>
          <tr><td>5</td><td>Ms. Raman Rani</td><td>M.Sc (Maths), B.Ed.</td></tr>
        </tbody>
      </table>
    </div>

    <hr class="divider">

    <h4 class="section-subtitle">Department Activities</h4>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2023–24</h5>
    <ul class="inner-lead">
      <li>International Literary Day Celebration</li>
      <li>Rubik's Cube Competition</li>
      <li>National Mathematics Day — Video Clips Competition</li>
      <li>Field Trip to Ottu Head</li>
      <li>Visit to Post Office</li>
    </ul>
    <h5 class="section-subtitle-orange" style="font-size:1rem;">2022–23</h5>
    <ul class="inner-lead">
      <li>National Mathematics Day — Seminar on Vedic Maths</li>
      <li>International Pie Day Celebration</li>
    </ul>

  </div>
</div>
